import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {environment} from "projects/store/src/environments/environment";
import {LocalStorageKey, ExternalSite, SalesWorkflowSteps, SalesWorkflow} from "projects/store/src/app/enums";
import {LocalStorageService, UtilService} from "library";
import {PixelService} from "../../../../services/api/v1/pixel.service";
import {PathNavigationService} from "projects/store/src/app/services/api/v1/path-navigation.service";

@Component({
  selector: 'app-sales-final-message-kredicash',
  templateUrl: './sales-final-message-kredicash.component.html',
})
export class SalesFinalMessageKredicashComponent implements OnInit {
  requestId: string;
  path: string;
  flowCode: string;
  data: any;

  @Input() message!: string;
  @Output() nextStepEvent = new EventEmitter();
  @Output() gotoStepEvent = new EventEmitter<{ flowCode: string; stepCode: string; categoryId?: string }>();

  country = environment.global.country;
  phoneNumber: string;

  protected readonly environment = environment;
  protected readonly ExternalSite = ExternalSite;
  protected readonly SalesWorkflowSteps = SalesWorkflowSteps;

  constructor(
    protected route: ActivatedRoute,
    protected router: Router,
    protected localStorageService: LocalStorageService,
    protected metaPixelService: PixelService,
    protected utilService: UtilService,
    protected pathNavigationService: PathNavigationService
  ) {
    this.requestId = this.route.snapshot.params['request_id'];
    this.path = this.route.snapshot.params['path'];
    this.flowCode = this.route.snapshot.params['flow_code'];
    this.data = this.localStorageService.get(LocalStorageKey.salesData);
    this.phoneNumber = this.country.customerServicePhone.replace(/\D/g, '');
  }

  get isFlowKrdya(): boolean {
    return this.flowCode === SalesWorkflow['app-krdya-kredicash'];
  }

  ngOnInit() {
    this.utilService.disablePageLoading();

    const purchaseEventKey = `purchase_event_sent_${this.requestId}`;
    const eventAlreadySent = sessionStorage.getItem(purchaseEventKey);

    if (!eventAlreadySent) {
      this.metaPixelService.trackEvent('Purchase');
      sessionStorage.setItem(purchaseEventKey, 'true');
    }
  }

  goTo() {
    window.location.href = this.data.external_callback_url;
  }

  openGooglePlay() {
    window.open('https://play.google.com/store/apps/details?id=com.kredipagos.luki&hl=es', '_blank');
  }

  onGotoStep(event: any): void {
    this.gotoStepEvent.emit(event);
  }

  onNextStep(): void {
    this.nextStepEvent.emit();
  }

  /**
   * Agrega el parámetro action=exit a la URL actual
   * Usado en el flujo app-krdya-kredicash para regresar a Krdya
   * Preserva los query params existentes (como start_token)
   */
  onBackToKrdya(): void {
    this.pathNavigationService.navigateToExitAppKrdya();
  }
}
